import React from 'react';
type PortraitFrameProps = {
  src: string;
  alt: string;
  caption?: string;
  backdropClass?: string;
  archClass?: string;
  className?: string;
  aspectClass?: string;
};

/**
 * Signature arch frame: a solid offset colour block behind an arch-topped image,
 * with a thin inset keyline. Used for every photograph on the site.
 */
export function PortraitFrame({
  src,
  alt,
  caption,
  backdropClass = 'bg-emerald',
  archClass = 'rounded-t-[10rem]',
  className = '',
  aspectClass = 'aspect-[4/5]'
}: PortraitFrameProps) {
  return <figure className={`relative ${className}`} data-id="element-33" data-mp="2d8mq8fo2j1sc">
      <div aria-hidden="true" className={`absolute inset-0 translate-x-4 translate-y-4 ${archClass} ${backdropClass}`} data-id="element-34" data-mp="28h4p9rm1p17d" />
      <div className={`relative overflow-hidden ${archClass} ${aspectClass}`} data-id="element-35" data-mp="23hs5xguduc9j">
        <img src={src} alt={alt} className="h-full w-full object-cover" data-id="element-36" data-mp="30yqv0qczt7kx" />
        <span aria-hidden="true" className={`pointer-events-none absolute inset-3 ${archClass} border border-white/45`} data-id="element-37" data-mp="2w78rpvnhyuws" />
      </div>
      {caption && <figcaption className="relative mt-6 max-w-xs font-sans text-[13px] leading-relaxed text-navy-400" data-id="element-38" data-mp="1sia2xg2tfn04">
          {caption}
        </figcaption>}
    </figure>;
}